






























































import { PropType } from 'vue'
import {
  AccessToggle,
  AccessToggleIdentifier
} from '~/models/user/access-toggles'
import { faBan, faCheck } from '@fortawesome/free-solid-svg-icons'
import { mapDeps } from '~/plugins/dependency-container/utils'
import AccessTogglesService from '~/services/user/AccessTogglesService'
import { defineComponent } from '~/utils/nuxt3-migration'
import CBadge from '~/components/shared/configurable/badge/CBadge.vue'

export default defineComponent({
  components: {
    CBadge
  },
  props: {
    accessToggle: {
      type: Object as PropType<AccessToggle>,
      required: true
    },
    identifier: {
      type: [String, Number] as PropType<AccessToggleIdentifier>,
      required: true
    }
  } as any,
  data(): { disallowReason: string | null; loading: boolean } {
    return {
      disallowReason: null,
      loading: false
    }
  },
  computed: {
    ...mapDeps({
      accessTogglesService: AccessTogglesService
    }),
    isAllowed() {
      return this.accessToggle.allow
    },
    icons: () => ({
      disallow: faBan,
      allow: faCheck
    })
  },
  methods: {
    toggleAccessToggle() {
      if (this.isAllowed) {
        return this.disallow()
      }
      return this.allow()
    },
    async allow() {
      this.loading = true
      const { identifier, accessToggle } = this
      try {
        const { message } = await this.accessTogglesService.enableAccessToggle(
          identifier,
          accessToggle.value
        )
        this.$snackbar.success(message)
        this.$emit('allow')
      } catch (error) {
        this.$logger.captureError(error)
      } finally {
        this.loading = false
      }
    },
    async disallow() {
      this.loading = true
      const { identifier, accessToggle, disallowReason } = this
      try {
        const { message } = await this.accessTogglesService.disableAccessToggle(
          identifier,
          accessToggle.value,
          disallowReason
        )
        this.$snackbar.success(message)
        this.$emit('disallow')
      } catch (error) {
        this.$logger.captureError(error)
      } finally {
        this.loading = false
      }
    }
  }
})
